import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';
import { GraphQLService } from '../graphql/graphql.service';
import * as loginSelectors from '../../../root-store/login-store/login.selector';
import { loaderTypes } from '@app/shared/component/loader/loader';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private searchValue = new BehaviorSubject('');
  currentSearchVal = this.searchValue.asObservable();
  currentUserDetails: any;

  constructor(
    private readonly httpService: AmplifyHttpClient,
    private readonly authService: AuthService,
    private readonly graphqlService: GraphQLService,
    private router: Router,
    private store: Store
  ) {
    this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
      if (result) {
        this.currentUserDetails = result;
      }
    });
  }

  init() {}

  setSearchValue(search_val: string) {
    this.searchValue.next(search_val);
  }

  /**
   * search method for
   * @param search_val
   * @param search_type
   * @return Observable
   */
  search(request) {
    //return this.httpService.post<any>(`api/search`, request).pipe(

    // request.user_id = this.authService.user.id;

    request.user_id = this.currentUserDetails.id;

    return this.graphqlService.search(request).pipe(
      map((response) => {
        return response;
      })
    );
  }

  searchVault(userId, searchValue, shared_user_id, vaultId = null) {
    let data = {
      userid: userId,
      searchtext: searchValue,
    };
    if (vaultId != null && vaultId != undefined) {
      data['vault_id'] = vaultId;
    }
    if (shared_user_id) {
      data['shared_user_id'] = shared_user_id;
    }
    let url = 'api/vault/vault-search';
    if (this.router.url.includes('network/shared-with-me/') && !this.router.url.includes('admin=true')) {
      url = 'api/vault/collaboration-search';
      const routeUrl = this.router.url.split('/');
      if (routeUrl.length > 4) {
        data['vault_id'] = routeUrl[4] == '0' ? null : routeUrl[4];
      }
    }

    return this.httpService.post<any>(url, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  searchShowAllVault(userId, searchValue, shared_user_id, vault_id = null) {
    let data = {
      userid: userId,
      searchtext: searchValue,
    };
    if (shared_user_id) {
      data['shared_user_id'] = shared_user_id;
    }
    if (vault_id != null && vault_id != undefined) {
      data['vault_id'] = vault_id;
    }
    let url = 'api/vault/vault-search-show-all';
    if (this.router.url.includes('search-shared-with-me-results-data') && !this.router.url.includes('admin=true')) {
      url = 'api/vault/collabortion-search-show-all';
    }
    const formatUrl = this.router.url.split('/');
    if (this.router.url.includes('shared-with-me') && formatUrl.length > 4) {
      data['vault_id'] = formatUrl[4] == '0' ? null : formatUrl[4];
    }
    return this.httpService.post<any>(url, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  searchOffice(data) {
    return this.httpService.post<any>(`api/office/search`, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  searchShowAllOffice(data) {
    return this.httpService.post<any>(`api/office/search-show-all`, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  searchInformationFolder(data) {
    return this.httpService.post<any>(`api/office-vault/search-folder`, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  searchInformationForm(data) {
    return this.httpService.post<any>(`api/office-vault/search-form`, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  searchShowAllInformationFolders(data) {
    return this.httpService.post<any>(`api/office-vault/search-folder-show-all`, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  searchShowAllInformationForms(data) {
    return this.httpService.post<any>(`api/office-vault/search-form-show-all`, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  searchTemplates(data) {
    return this.httpService.post<any>(`api/search/get-templates`, data, loaderTypes.default).pipe(
      map((response) => {
        return response;
      })
    );
  }

  searchDocument(data) {
    return this.httpService.post<any>(`api/search/get-documents`, data, loaderTypes.default).pipe(
      map((response) => {
        return response;
      })
    );
  }
}
